import { Component, OnInit, Input } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from "@angular/forms";
import { HttpClient, HttpEventType } from '@angular/common/http';
import { AuthService } from '../shared/services/auth.service';
import { ApiService } from '../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { Informes } from '../model/informes';
import { Usuarios } from '../dashboard/models/usuarios';
import { environment } from "../../environments/environment.prod";
import { PlazosDenuncia } from '../model/plazosDenuncia';
import { DatePipe } from '@angular/common';
import { noWhitespaceValidator, sanitizeHtml } from '../shared/custom-validator/custom-validator.component';

@Component({
  selector: 'app-asignar-receptor',
  templateUrl: './asignar-receptor.component.html',
  styleUrls: ['./asignar-receptor.component.css'],
  providers: [DatePipe]
})
export class AsignarReceptorComponent implements OnInit {
  assetsUrl: string = environment.baseAssetsUrl;
  myForm: FormGroup;
  IsHiddenForm: boolean = false;
  @Input() denuncia: DatosDenuncia;
  receptorTipoDen: Usuarios[];
  receptores2: Usuarios[];
  /** Indicates when `receptores2` list is ready to be rendered in the template. */
  receptores2Ready = false;
  plazos: PlazosDenuncia[];
  receptor_select: Usuarios[];

  constructor(private apiService: ApiService, private auth: AuthService, private router: Router, private toastr: ToastrService, private translate: TranslateService, private actRoute: ActivatedRoute) { }

  ngOnInit(): void {
    let language = this.auth.getLanguage();
    if (language == '' || language == null) {
      language = 'es';
    }
    this.translate.setDefaultLang(language);

    this.myForm = new FormGroup({
      selectReceptor: new FormControl('', [Validators.required])
    });

    this.receptores2Ready = false;

    const idDenuncia = this.actRoute.snapshot.paramMap.get('id');
    this.loadInitialLists(idDenuncia);
  }

  /** Load receptor lists and reports used by the component. */
  private loadInitialLists(idDenuncia: string): void {
    this.apiService.searchUserByIdSocietyRole(this.auth.getSociedad(), '1', false, idDenuncia).subscribe((usuarios: Usuarios[]) => {
      this.receptorTipoDen = usuarios;
    });

    this.apiService.searchInvesSelect(this.auth.getSociedad(), idDenuncia, '1').subscribe({
      next: (usuarios2) => {
        this.receptor_select = usuarios2.data;
      }, error: () => {
        this.receptor_select = [];
      }
    });
  }

  get selectReceptor() {
    return this.myForm.get('selectReceptor');
  }

  asignarReceptor() {
    if (this.selectReceptor.value) {
      this.apiService.createUserByIdComplaint(this.auth.getSociedad(), this.selectReceptor.value, this.denuncia[0].id_denuncia, '1', '0', '0', true).subscribe(
        createRes => {
          if (createRes == 200) {
            this.toastr.success(this.translate.instant('texto_496'), this.translate.instant('texto_495'));
          }
          this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
            this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
          });
        },
        () => {
          this.toastr.error(this.translate.instant('texto_497'), this.translate.instant('texto_495'));
        }
      );
    } else {
      this.toastr.error(this.translate.instant('texto_531'), this.translate.instant('texto_533'));
    }
  }

  deletereceptor(id_user: string) {
    this.apiService.countInvesSelect(this.auth.getSociedad(), this.denuncia[0].id_denuncia, id_user, "1").subscribe(
      res => {
        if (res == 200) {
          this.apiService.deleteInvesSelect(id_user, this.auth.getSociedad(), this.denuncia[0].id_denuncia, "1").subscribe(
            res => {
              if (res == 200) {
                this.toastr.success(this.translate.instant('texto_949'), this.translate.instant('texto_948'));
              } else {
                this.toastr.error(this.translate.instant('texto_950'), this.translate.instant('texto_948'));
              }
              this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
                this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
              });
            });
        } else {
          this.toastr.error(this.translate.instant('texto_464'), this.translate.instant('texto_495'));
        }
        this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
          this.router.navigate(['editar-denuncia/', this.denuncia[0].id_denuncia]);
        });
      });
  }

  /**
   * Load available receivers, excluding those with conflicts of interest.
   */
  getAvailablereceiver() {
    // get receiversgetAvailablereceiver
    this.apiService.searchUserByIdSocietyRole(this.auth.getSociedad(), "1", false, "nulo").subscribe({
      next: (response: any) => {
        const list = response || [];

        this.receptores2 = list.filter((d: any) =>
          String(d.id_user ?? "") !== String(this.receptorTipoDen?.[0]?.id_user ?? "") &&
          String(d.id_user ?? "") !== String(this.denuncia?.[0]?.id_receptor_rechazado ?? "") &&
          !(this.receptor_select?.some((u: any) => String(u.id_user ?? "") === String(d.id_user ?? "")))
        );

        if (this.receptores2.length === 0) {
          this.toastr.error(this.translate.instant("texto_931"));
        }

        this.receptores2Ready = true;
      },

      error: () => {
        this.receptores2 = [];
        this.receptores2Ready = true;
        if (!this.receptorTipoDen?.[0]?.id_user) {
          this.toastr.error(this.translate.instant("texto_890"));
        }
      },
    });
  }
} 0
